import { A } from '@solidjs/router';

export default function NotFound() {
  return (
    <div class="page">
      <div class="empty">
        <h2>There’s no page here</h2>
        <p>The link may be out of date.</p>
        <A class="btn" href="/">
          Go to bookmarks
        </A>
      </div>
    </div>
  );
}
